export enum NoDataError {
	LocationNotFound = 'Location variables for the boat not found',
	HistogramNotFound = 'Histogram data not found for given period of time',
	AccountDeleted = 'Your account no longer exists',
	UsernameNotFound = 'No account exists for the entered username. Please verify and try again.',
	EmailNotFound = 'No account exists for the entered email. Please verify and try again.',
}

export enum NoDataErrorWithoutDetail {
	UserNotFound = 'User with username',
}

export const NoDataErrorTranslation: Record<
	NoDataError,
	| 'toast.error.noDataLocationError'
	| 'toast.error.noDataHistogramError'
	| 'toast.error.accountDeletedError'
	| 'toast.error.noDataUsernameError'
	| 'toast.error.noDataEmailError'
> = {
	[NoDataError.LocationNotFound]: 'toast.error.noDataLocationError',
	[NoDataError.HistogramNotFound]: 'toast.error.noDataHistogramError',
	[NoDataError.AccountDeleted]: 'toast.error.accountDeletedError',
	[NoDataError.UsernameNotFound]: 'toast.error.noDataUsernameError',
	[NoDataError.EmailNotFound]: 'toast.error.noDataEmailError',
};
